import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        {/* Wrap your App with the OrientationGuard */}
        <OrientationGuard>
            <App />
        </OrientationGuard>
    </React.StrictMode>
);

// Define the component either in this file or import it
function OrientationGuard({ children }) {
  return (
    <>
      <div className="orientation-warning">
        <h1>Please rotate your device</h1>
        <p>This website is best experienced in Portrait mode.</p>
      </div>
      <div className="main-app-content">
        {children}
      </div>
    </>
  );
}